var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 30,
    fill: "none",
    viewBox: "0 0 44 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.8596 24.8291V11.9299H0V24.8291C0 27.3524 2.04547 29.3978 4.56869 29.3977H39.2909C41.8141 29.3977 43.8596 27.3523 43.8596 24.8291ZM31.5789 24.6909C32.0583 24.6909 32.5077 24.5627 32.8947 24.3388C33.2818 24.5627 33.7312 24.6909 34.2105 24.6909C35.6639 24.6909 36.8421 23.5127 36.8421 22.0593C36.8421 20.6059 35.6639 19.4277 34.2105 19.4277C33.7312 19.4277 33.2818 19.5559 32.8947 19.7798C32.5077 19.5559 32.0583 19.4277 31.5789 19.4277C30.1256 19.4277 28.9474 20.6059 28.9474 22.0593C28.9474 23.5127 30.1256 24.6909 31.5789 24.6909ZM14.6199 20.1872H5.48246V18.4328H14.6199V20.1872ZM5.48246 23.8422H20.1024V22.0878H5.48246V23.8422Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.8949 24.3674C33.6815 23.9124 34.2107 23.0619 34.2107 22.0879C34.2107 21.1138 33.6815 20.2634 32.8949 19.8083C32.1083 20.2634 31.5791 21.1138 31.5791 22.0879C31.5791 23.0619 32.1083 23.9124 32.8949 24.3674Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.56869 0.157959H39.2909C41.8141 0.157959 43.8596 2.13745 43.8596 4.57928V6.29831H0V4.57936C0 2.13745 2.04547 0.157959 4.56869 0.157959Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.ab3f8cac29a0c8e4053a4941a498f8b4.svg";
export { ForwardRef as ReactComponent };